// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 10 6%27%3e %3cpath stroke=%27%236B7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m1 1 4 4 4-4%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M1 5.917 5.724 10.5 15 1.5%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M0.5 6h14%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/EditorLightEffect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/InputLightEffect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/Effect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/SidebarLightEffect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Youth-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Youth-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/Youth-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/Youth-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/Youth-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/Youth-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/Youth-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/Youth-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./fonts/Youth-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./fonts/Youth-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./fonts/Youth-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./fonts/Youth-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E5E7EB; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Outfit, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before {
  border-style: solid;
  border-color: #e5e7eb;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: -4px;
}

.tooltip.invisible > .tooltip-arrow:before {
  visibility: hidden;
}

[data-popper-arrow],[data-popper-arrow]:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

[data-popper-arrow] {
  visibility: hidden;
}

[data-popper-arrow]:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-popper-arrow]:after {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  position: absolute;
  width: 9px;
  height: 9px;
  background: inherit;
}

[role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #4b5563;
}

[role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #4b5563;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow] {
  bottom: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow] {
  top: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow] {
  right: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow] {
  left: -5px;
}

[type='text'],[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}

[type='text']:focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #1C64F2, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #1C64F2;
}

input::-moz-placeholder, textarea::-moz-placeholder {
  color: #6B7280;
  opacity: 1;
}

input::placeholder,textarea::placeholder {
  color: #6B7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
}

select:not([size]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 0.75em 0.75em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[dir=rtl] select:not([size]) {
  background-position: left 0.75rem center;
  padding-right: 0.75rem;
  padding-left: 0;
}

[multiple] {
  background-image: none;
  background-image: initial;
  background-position: 0 0;
  background-position: initial;
  background-repeat: repeat;
  background-repeat: initial;
  background-size: auto auto;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: inherit;
          print-color-adjust: inherit;
}

[type='checkbox'],[type='radio'] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #1C64F2;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #1C64F2, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked,.dark [type='checkbox']:checked,.dark [type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 0.55em 0.55em;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

.dark [type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: currentColor;
  border-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px auto inherit;
}

input[type=file]::file-selector-button {
  color: white;
  background: #1F2937;
  border: 0;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-left: -1rem;
  margin-right: 1rem;
}

input[type=file]::file-selector-button:hover {
  background: #374151;
}

[dir=rtl] input[type=file]::file-selector-button {
  padding-right: 2rem;
  padding-left: 1rem;
}

.dark input[type=file]::file-selector-button {
  color: white;
  background: #4B5563;
}

.dark input[type=file]::file-selector-button:hover {
  background: #6B7280;
}

input[type="range"]::-webkit-slider-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-webkit-slider-thumb {
  background: #6B7280;
}

input[type="range"]:focus::-webkit-slider-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1px;
  --tw-ring-color: rgba(164, 202, 254, var(--tw-ring-opacity));
}

input[type="range"]::-moz-range-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-moz-range-thumb {
  background: #6B7280;
}

input[type="range"]::-moz-range-progress {
  background: #3F83F8;
}

input[type="range"]::-ms-fill-lower {
  background: #3F83F8;
}

  :root {
    --color-primary: 247 147 34;
    --color-text: 33 33 33;
    --color-light: 245 245 245;
    --color-success: 0 200 81;
    --color-info: 51 181 229;
    --color-warn: 255 187 51;
    --color-error: 254 78 78;
    --color-surface: 23 23 23;
    --color-accent: 235 255 66;
    /* new colors */
    --accent: #EBFF42;
    --font: #FFFFFF;
    --font-on-accent: #101010;
    --font-variant: #A3A3A3;
    --border: #101010;
    --surface: #303030;
    --font-disabled: #545454;
    --surface-disabled: #222222;
    --surface-active: #414141;
    --surface-transparent: rgba(255,255,255,0.03922);
    --surface-transparent-active: rgba(255,255,255,0.12157);
    --success-new: #70FFBD;
    --background: #1F1F1F;
    --danger: #FA2565;
    --overlay: rgba(21,21,21,0.47843);
  }

  :root[class="dark"] {
    --color-primary: 247 147 34;
    --color-text: 33 33 33;
    --color-light: 245 245 245;
    --color-success: 0 200 81;
    --color-info: 51 181 229;
    --color-warn: 255 187 51;
    --color-error: 254 78 78;
    --color-surface: 23 23 23;
    --color-accent: 235 255 66;
    /* new colors */
    --accent: #EBFF42;
    --font: #FFFFFF;
    --font-on-accent: #101010;
    --font-variant: #A3A3A3;
    --border: #101010;
    --surface: #303030;
    --font-disabled: #545454;
    --surface-disabled: #222222;
    --surface-active: #414141;
    --surface-transparent: rgba(255,255,255,0.03922);
    --surface-transparent-active: rgba(255,255,255,0.12157);
    --success-new: #70FFBD;
    --background: #1F1F1F;
    --danger: #FA2565;
    --overlay: rgba(21,21,21,0.47843);
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(63, 131, 248, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(63, 131, 248, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.pointer-events-none {
  pointer-events: none;
}
.static {
  position: static;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-1 {
  top: 0.25rem;
  bottom: 0.25rem;
}
.inset-y-1\\.5 {
  top: 0.375rem;
  bottom: 0.375rem;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-bottom-2\\.5 {
  bottom: -0.625rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-\\[30px\\] {
  bottom: 30px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.-mx-0 {
  margin-left: -0px;
  margin-right: -0px;
}
.-mx-0\\.5 {
  margin-left: -0.125rem;
  margin-right: -0.125rem;
}
.-mx-\\[1\\.5px\\] {
  margin-left: -1.5px;
  margin-right: -1.5px;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-mb-\\[3px\\] {
  margin-bottom: -3px;
}
.-mt-\\[1\\.5px\\] {
  margin-top: -1.5px;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.box-content {
  box-sizing: content-box;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\/3 {
  height: 66.666667%;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[13px\\] {
  height: 13px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[19\\.5px\\] {
  height: 19.5px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[32px\\] {
  max-height: 32px;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-32 {
  min-height: 8rem;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-2 {
  width: 0.5rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[19\\.5px\\] {
  width: 19.5px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[325px\\] {
  width: 325px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[480px\\] {
  width: 480px;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: -moz-max-content;
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.\\!min-w-0 {
  min-width: 0px !important;
}
.min-w-12 {
  min-width: 3rem;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[25ch\\] {
  max-width: 25ch;
}
.max-w-\\[30ch\\] {
  max-width: 30ch;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.-translate-y-\\[calc\\(100\\%\\+6px\\)\\] {
  --tw-translate-y: calc(calc(100% + 6px) * -1);
  transform: translate(var(--tw-translate-x), calc((100% + 6px) * -1)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), calc(calc(100% + 6px) * -1)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), 0.25rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\.5 {
  --tw-translate-y: 0.375rem;
  transform: translate(var(--tw-translate-x), 0.375rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.\\!gap-0 {
  gap: 0px !important;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-\\[9px\\] {
  gap: 9px;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.break-words {
  word-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-e-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-s-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[34px\\] {
  border-top-left-radius: 34px;
  border-top-right-radius: 34px;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.\\!border-2 {
  border-width: 2px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-x-2 {
  border-left-width: 2px;
  border-right-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-\\[3px\\] {
  border-top-width: 3px;
}
.border-none {
  border-style: none;
}
.\\!border-border {
  border-color: #101010 !important;
  border-color: var(--border) !important;
}
.border-\\[\\#272727\\] {
  --tw-border-opacity: 1;
  border-color: rgba(39, 39, 39, 1);
  border-color: rgba(39, 39, 39, var(--tw-border-opacity));
}
.border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgba(26, 86, 219, 1);
  border-color: rgba(26, 86, 219, var(--tw-border-opacity));
}
.border-border {
  border-color: #101010;
  border-color: var(--border);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.border-l-gray-100 {
  --tw-border-opacity: 1;
  border-left-color: rgba(243, 244, 246, 1);
  border-left-color: rgba(243, 244, 246, var(--tw-border-opacity));
}
.bg-\\[\\#333\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(51, 51, 51, 1);
  background-color: rgba(51, 51, 51, var(--tw-bg-opacity));
}
.bg-\\[\\#EBFF4214\\] {
  background-color: rgba(235,255,66,0.07843);
}
.bg-\\[\\#FA25651F\\] {
  background-color: rgba(250,37,101,0.12157);
}
.bg-\\[lightgray\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(211, 211, 211, 1);
  background-color: rgba(211, 211, 211, var(--tw-bg-opacity));
}
.bg-\\[rgba\\(0\\2c _0\\2c _0\\2c _0\\.10\\)\\] {
  background-color: rgba(0, 0, 0, 0.10);
}
.bg-accent {
  background-color: #EBFF42;
  background-color: var(--accent);
}
.bg-background {
  background-color: #1F1F1F;
  background-color: var(--background);
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(26, 86, 219, 1);
  background-color: rgba(26, 86, 219, var(--tw-bg-opacity));
}
.bg-border {
  background-color: #101010;
  background-color: var(--border);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}
.bg-outline {
  background-color: rgba(123,123,123,0.32157);
}
.bg-surface {
  background-color: #303030;
  background-color: var(--surface);
}
.bg-surface-disabled {
  background-color: #222222;
  background-color: var(--surface-disabled);
}
.bg-surface-muted {
  background-color: rgba(123,123,123,0.07843);
}
.bg-surface-transparent {
  background-color: rgba(255,255,255,0.03922);
  background-color: var(--surface-transparent);
}
.bg-surface-variant-muted {
  background-color: rgba(49,49,49,0.23922);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-editor-gradient {
  background-image: linear-gradient(180deg, rgba(23, 23, 23, 0.00) 56.48%, rgba(31, 31, 31, 0.80) 100%), radial-gradient(108.43% 100% at 51.83% 100%, rgba(23, 23, 23, 0.48) 0%, rgba(23, 23, 23, 0.00) 100%), linear-gradient(0deg, rgba(235, 255, 66, 0.12) 0%, rgba(235, 255, 66, 0.12) 100%);
}
.bg-editor-light-effect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bg-function-gradient {
  background-image: linear-gradient(180deg, rgba(43, 43, 43, 0.00) 56.48%, rgba(51, 51, 51, 0.80) 100%), radial-gradient(108.43% 100% at 51.83% 100%, rgba(43, 43, 43, 0.48) 0%, rgba(43, 43, 43, 0.00) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%);
}
.bg-input-gradient {
  background-image: linear-gradient(0deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%), linear-gradient(180deg, rgba(43, 43, 43, 0.00) 56.48%, rgba(51, 51, 51, 0.80) 100%), radial-gradient(108.43% 100% at 51.83% 100%, rgba(43, 43, 43, 0.48) 0%, rgba(43, 43, 43, 0.00) 100%);
}
.bg-input-light-effect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.bg-screen-effect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.bg-sidebar-light-effect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.bg-surface-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.04) 118.92%);
}
.bg-cover {
  background-size: cover;
}
.bg-left-top {
  background-position: left top;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-font-variant {
  fill: #A3A3A3;
  fill: var(--font-variant);
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[3px\\] {
  padding: 3px;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-0\\.5 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-\\[5px\\] {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[1\\.5px\\] {
  padding-left: 1.5px;
  padding-right: 1.5px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\!pr-1 {
  padding-right: 0.25rem !important;
}
.\\!pr-1\\.5 {
  padding-right: 0.375rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-\\[3px\\] {
  padding-bottom: 3px;
}
.pb-\\[5px\\] {
  padding-bottom: 5px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-\\[5px\\] {
  padding-left: 5px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-\\[52px\\] {
  padding-right: 52px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-\\[1\\.5px\\] {
  padding-top: 1.5px;
}
.pt-\\[7px\\] {
  padding-top: 7px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-youth {
  font-family: Youth;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-\\[48px\\] {
  line-height: 48px;
}
.\\!text-font-disabled {
  color: #545454 !important;
  color: var(--font-disabled) !important;
}
.text-\\[\\#CAF7B2\\] {
  --tw-text-opacity: 1;
  color: rgba(202, 247, 178, 1);
  color: rgba(202, 247, 178, var(--tw-text-opacity));
}
.text-accent {
  color: #EBFF42;
  color: var(--accent);
}
.text-danger {
  color: #FA2565;
  color: var(--danger);
}
.text-font {
  color: #FFFFFF;
  color: var(--font);
}
.text-font-disabled {
  color: #545454;
  color: var(--font-disabled);
}
.text-font-on-accent {
  color: #101010;
  color: var(--font-on-accent);
}
.text-font-variant {
  color: #A3A3A3;
  color: var(--font-variant);
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgba(229, 231, 235, 1);
  color: rgba(229, 231, 235, var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}
.text-info {
  color: rgb(51, 181, 229);
  color: rgb(var(--color-info));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.line-through {
  text-decoration-line: line-through;
}
.caret-accent {
  caret-color: #EBFF42;
  caret-color: var(--accent);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-\\[0\\.16\\] {
  opacity: 0.16;
}
.mix-blend-multiply {
  mix-blend-mode: multiply;
}
.mix-blend-soft-light {
  mix-blend-mode: soft-light;
}
.shadow-editor {
  --tw-shadow: 0px 0px 0px 6px rgba(31, 31, 31, 0.40) inset;
  --tw-shadow-colored: inset 0px 0px 0px 6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 0px 0px 6px rgba(31, 31, 31, 0.40) inset;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-modal {
  --tw-shadow: 12px 12px 0px 0px rgba(0, 0, 0, 0.24);
  --tw-shadow-colored: 12px 12px 0px 0px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 12px 12px 0px 0px rgba(0, 0, 0, 0.24);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.\\!ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-\\[160ms\\] {
  transition-duration: 160ms;
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[appearance\\:textfield\\] {
  -webkit-appearance: textfield;
     -moz-appearance: textfield;
          appearance: textfield;
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('opentype');
}

@font-face {
  font-display: block;
  font-family: 'Youth';
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('opentype');
}

body {
  margin: 0;
  overflow: hidden;
}

.hide-scrollbars {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.hide-scrollbars::-webkit-scrollbar {
  /* WebKit */
  width: 0;
  height: 0;
  background: transparent;
  display: none;
}

.icon {
  position: relative;
}

.icon::before {
  position: absolute;
  left: 100%;
  top: 0;
  font-size: 0.9em;
  display: block;
}

.icon.okay::before {
  color: green;
  content: "✔";
}

.icon.ignored::before {
  /* content: '*️⃣'; */
  color: darkgray;
  opacity: 0.8;
  content: "✔";
}

.icon.error::before {
  content: "⛔";
}

.icon.warning::before {
  content: "⚠️";
}

.globalError {
  position: fixed;
  background-color: #cf3939;
  color: white;
  bottom: 20px;
  right: 20px;
  opacity: 0.4;
  padding: 20px;
  z-index: 10000;
  overflow: auto;
  max-width: 30vw;
  max-height: 30vh;
}


.popupContent {
  text-align: center;
}

.popupContainer {
  display: inline-block;
}

pre {
  text-align: left;
}

.buttons {
  position: fixed;
  right: 3vh;
  bottom: 3vh;
}


.buttons>div {
  size: 1vh;
  color: white;
  background: green;
  text-align: center;
  margin: 1vh;
  padding: 1.1vh;
  cursor: pointer;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 0.5vh;
}

.buttons.error>div {
  background: grey;
  cursor: not-allowed;
}



.wrapper {
  display: flex;
  flex-direction: column;
  background-color: black;
  color: white;
  font-family: monospace;
  font-size: 12px;
  padding: 10px;
  height: 20vh;
}

.promptWrapper {
  display: flex;
}

.line {
  font-size: 12px;
  line-height: 12px;
  font-family: monospace;
  background: transparent !important;
  /* we want to make this transparent whatever happens in the app*/
  padding: 0;
  color: white;
}

.line.command {
  font-weight: bold;
}

.line.error,
.line.success {
  padding-left: 20px;
  position: relative;
}

.line.error {
  color: #cf3939;
  position: relative;
}

.line.error::before,
.line.success::before {
  display: block;
  position: absolute;
  top: 2px;
  left: 0;
}

.line.error::before {
  content: '❌ ';
}

.line.success::before {
  content: '✅ ';
}

.prompt {
  display: flex;
  align-items: center;
}

input:focus{
  outline: none;
  box-shadow: none;
}

.resultLabel {
  color: dimgrey;
}

.warn {
  color: darkorange;
}

textarea {
  resize: none;
}

.monaco-editor, .monaco-editor-background, .monaco-editor .margin {
  background-color: transparent !important;
}

.monaco-editor {
  --vscode-focusBorder: transparent !important;
}

.scroll-decoration {
  visibility: hidden;
}

.margin-view-overlays .line-numbers::after {
  content: '.';
}

.monaco-editor { 
  position: absolute !important; 
}

.placeholder\\:text-font-variant::-moz-placeholder {
  color: #A3A3A3;
  color: var(--font-variant);
}

.placeholder\\:text-font-variant::placeholder {
  color: #A3A3A3;
  color: var(--font-variant);
}

.backdrop\\:bg-overlay::backdrop {
  background-color: rgba(21,21,21,0.47843);
  background-color: var(--overlay);
}

.hover\\:bg-\\[\\#FA25651F\\]:hover {
  background-color: rgba(250,37,101,0.12157);
}

.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(30, 66, 159, 1);
  background-color: rgba(30, 66, 159, var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(17, 24, 39, 1);
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgba(26, 86, 219, 1);
  color: rgba(26, 86, 219, var(--tw-text-opacity));
}

.focus\\:z-10:focus {
  z-index: 10;
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(63, 131, 248, 1);
  border-color: rgba(63, 131, 248, var(--tw-border-opacity));
}

.focus\\:text-blue-700:focus {
  --tw-text-opacity: 1;
  color: rgba(26, 86, 219, 1);
  color: rgba(26, 86, 219, var(--tw-text-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(164, 202, 254, var(--tw-ring-opacity));
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(63, 131, 248, var(--tw-ring-opacity));
}

.focus\\:ring-blue-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(26, 86, 219, var(--tw-ring-opacity));
}

.focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(209, 213, 219, var(--tw-ring-opacity));
}

.active\\:pb-0:active {
  padding-bottom: 0px;
}

.active\\:pb-0\\.5:active {
  padding-bottom: 0.125rem;
}

.active\\:pt-\\[3px\\]:active {
  padding-top: 3px;
}

.disabled\\:placeholder\\:text-font-disabled:disabled::-moz-placeholder {
  color: #545454;
  color: var(--font-disabled);
}

.disabled\\:placeholder\\:text-font-disabled:disabled::placeholder {
  color: #545454;
  color: var(--font-disabled);
}

.group:hover .group-hover\\:fill-danger {
  fill: #FA2565;
  fill: var(--danger);
}

.group:active .group-active\\:-mb-0 {
  margin-bottom: -0px;
}

.group:active .group-active\\:-mb-0\\.5 {
  margin-bottom: -0.125rem;
}

.group:active .group-active\\:-mt-\\[3px\\] {
  margin-top: -3px;
}

.group:active .group-active\\:border-b-2 {
  border-bottom-width: 2px;
}

.group:active .group-active\\:border-t-\\[3px\\] {
  border-top-width: 3px;
}

.group:active .group-active\\:bg-surface-active {
  background-color: #414141;
  background-color: var(--surface-active);
}

.group:active .group-active\\:pb-\\[3px\\] {
  padding-bottom: 3px;
}

.group:active .group-active\\:pb-\\[5px\\] {
  padding-bottom: 5px;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled=true] {
  pointer-events: none;
}

.data-\\[disabled\\=true\\]\\:cursor-default[data-disabled=true] {
  cursor: default;
}

.data-\\[active\\=true\\]\\:border-b-2[data-active=true] {
  border-bottom-width: 2px;
}

.data-\\[active\\=true\\]\\:border-t-\\[3px\\][data-active=true] {
  border-top-width: 3px;
}

.data-\\[active\\=true\\]\\:bg-accent[data-active=true] {
  background-color: #EBFF42;
  background-color: var(--accent);
}

.data-\\[active\\=true\\]\\:bg-surface-active[data-active=true] {
  background-color: #414141;
  background-color: var(--surface-active);
}

.data-\\[active\\=true\\]\\:bg-surface-transparent-active[data-active=true] {
  background-color: rgba(255,255,255,0.12157);
  background-color: var(--surface-transparent-active);
}

.data-\\[active\\=true\\]\\:data-\\[variant\\=accent\\]\\:bg-accent[data-variant=accent][data-active=true] {
  background-color: #EBFF42;
  background-color: var(--accent);
}

.data-\\[active\\=true\\]\\:data-\\[variant\\=surface\\]\\:bg-surface-active[data-variant=surface][data-active=true] {
  background-color: #414141;
  background-color: var(--surface-active);
}

.data-\\[disabled\\=true\\]\\:bg-\\[\\#222\\][data-disabled=true] {
  --tw-bg-opacity: 1;
  background-color: rgba(34, 34, 34, 1);
  background-color: rgba(34, 34, 34, var(--tw-bg-opacity));
}

.data-\\[disabled\\=true\\]\\:bg-surface[data-disabled=true] {
  background-color: #303030;
  background-color: var(--surface);
}

.data-\\[focus\\=true\\]\\:bg-surface-transparent-active[data-focus=true] {
  background-color: rgba(255,255,255,0.12157);
  background-color: var(--surface-transparent-active);
}

.data-\\[open\\=true\\]\\:bg-surface-transparent-active[data-open=true] {
  background-color: rgba(255,255,255,0.12157);
  background-color: var(--surface-transparent-active);
}

.data-\\[variant\\=accent\\]\\:bg-accent[data-variant=accent] {
  background-color: #EBFF42;
  background-color: var(--accent);
}

.data-\\[variant\\=background\\]\\:bg-background[data-variant=background] {
  background-color: #1F1F1F;
  background-color: var(--background);
}

.data-\\[variant\\=error\\]\\:bg-danger[data-variant=error] {
  background-color: #FA2565;
  background-color: var(--danger);
}

.data-\\[variant\\=neutral\\]\\:bg-surface[data-variant=neutral] {
  background-color: #303030;
  background-color: var(--surface);
}

.data-\\[variant\\=success\\]\\:bg-success-new[data-variant=success] {
  background-color: #70FFBD;
  background-color: var(--success-new);
}

.data-\\[variant\\=surface\\]\\:bg-surface[data-variant=surface] {
  background-color: #303030;
  background-color: var(--surface);
}

.data-\\[disabled\\=true\\]\\:bg-input-disabled-gradient[data-disabled=true] {
  background-image: linear-gradient(0deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%), linear-gradient(180deg, rgba(26, 26, 26, 0.00) 56.48%, rgba(34, 34, 34, 0.80) 100%), radial-gradient(108.43% 100% at 51.83% 100%, rgba(26, 26, 26, 0.48) 0%, rgba(26, 26, 26, 0.00) 100%);
}

.data-\\[focus\\=true\\]\\:bg-input-active-gradient[data-focus=true] {
  background-image: linear-gradient(0deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), linear-gradient(180deg, rgba(43, 43, 43, 0.00) 56.48%, rgba(51, 51, 51, 0.80) 100%), radial-gradient(108.43% 100% at 51.83% 100%, rgba(43, 43, 43, 0.48) 0%, rgba(43, 43, 43, 0.00) 100%);
}

.data-\\[active\\=true\\]\\:fill-accent[data-active=true] {
  fill: #EBFF42;
  fill: var(--accent);
}

.data-\\[color\\=default\\]\\:fill-font[data-color=default] {
  fill: #FFFFFF;
  fill: var(--font);
}

.data-\\[color\\=disabled\\]\\:fill-font-disabled[data-color=disabled] {
  fill: #545454;
  fill: var(--font-disabled);
}

.data-\\[color\\=on-accent\\]\\:fill-font-on-accent[data-color=on-accent] {
  fill: #101010;
  fill: var(--font-on-accent);
}

.data-\\[color\\=variant\\]\\:fill-font-variant[data-color=variant] {
  fill: #A3A3A3;
  fill: var(--font-variant);
}

.data-\\[variant\\=accent\\]\\:fill-accent[data-variant=accent] {
  fill: #EBFF42;
  fill: var(--accent);
}

.data-\\[variant\\=danger\\]\\:fill-danger[data-variant=danger] {
  fill: #FA2565;
  fill: var(--danger);
}

.data-\\[variant\\=default\\]\\:fill-font[data-variant=default] {
  fill: #FFFFFF;
  fill: var(--font);
}

.data-\\[variant\\=default\\]\\:fill-font-variant[data-variant=default] {
  fill: #A3A3A3;
  fill: var(--font-variant);
}

.data-\\[variant\\=disabled\\]\\:fill-font-disabled[data-variant=disabled] {
  fill: #545454;
  fill: var(--font-disabled);
}

.data-\\[active\\=false\\]\\:pr-\\[21px\\][data-active=false] {
  padding-right: 21px;
}

.data-\\[active\\=true\\]\\:pl-\\[21px\\][data-active=true] {
  padding-left: 21px;
}

.data-\\[level\\=level-2\\]\\:pl-\\[27px\\][data-level=level-2] {
  padding-left: 27px;
}

.data-\\[level\\=level-3\\]\\:pl-\\[46px\\][data-level=level-3] {
  padding-left: 46px;
}

.data-\\[level\\=level-4\\]\\:pl-\\[65px\\][data-level=level-4] {
  padding-left: 65px;
}

.data-\\[open\\=true\\]\\:pb-4[data-open=true] {
  padding-bottom: 1rem;
}

.data-\\[active\\=false\\]\\:text-font-variant[data-active=false] {
  color: #A3A3A3;
  color: var(--font-variant);
}

.data-\\[active\\=true\\]\\:text-font[data-active=true] {
  color: #FFFFFF;
  color: var(--font);
}

.data-\\[disabled\\=true\\]\\:text-font-disabled[data-disabled=true] {
  color: #545454;
  color: var(--font-disabled);
}

.data-\\[open\\=true\\]\\:text-accent[data-open=true] {
  color: #EBFF42;
  color: var(--accent);
}

.data-\\[disabled\\=true\\]\\:opacity-40[data-disabled=true] {
  opacity: 0.4;
}

.data-\\[variant\\=accent\\]\\:shadow-dot-accent[data-variant=accent] {
  --tw-shadow: 0px 0px 0px 2px #EBFF42, 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  --tw-shadow-colored: 0px 0px 0px 2px var(--tw-shadow-color), inset 0px 0px 0px 1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 0px 0px 2px #EBFF42, 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.data-\\[variant\\=error\\]\\:shadow-dot-danger[data-variant=error] {
  --tw-shadow: 0px 0px 0px 2px #FA2565, 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  --tw-shadow-colored: 0px 0px 0px 2px var(--tw-shadow-color), inset 0px 0px 0px 1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 0px 0px 2px #FA2565, 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.data-\\[variant\\=neutral\\]\\:shadow-dot-neutral[data-variant=neutral] {
  --tw-shadow: 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  --tw-shadow-colored: inset 0px 0px 0px 1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.data-\\[variant\\=success\\]\\:shadow-dot-success[data-variant=success] {
  --tw-shadow: 0px 0px 0px 2px #70FFBD, 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  --tw-shadow-colored: 0px 0px 0px 2px var(--tw-shadow-color), inset 0px 0px 0px 1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 0px 0px 2px #70FFBD, 0px 0px 0px 1px rgba(31, 31, 31, 0.24) inset;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.data-\\[disabled\\=true\\]\\:grayscale[data-disabled=true] {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) grayscale(100%) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.data-\\[open\\=false\\]\\:grayscale[data-open=false] {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) grayscale(100%) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark .dark\\:border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgba(75, 85, 99, 1);
  border-color: rgba(75, 85, 99, var(--tw-border-opacity));
}

.dark .dark\\:border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, 1);
  border-color: rgba(55, 65, 81, var(--tw-border-opacity));
}

.dark .dark\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(28, 100, 242, 1);
  background-color: rgba(28, 100, 242, var(--tw-bg-opacity));
}

.dark .dark\\:bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, 1);
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));
}

.dark .dark\\:bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}

.dark .dark\\:bg-surface {
  background-color: #303030;
  background-color: var(--surface);
}

.dark .dark\\:text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}

.dark .dark\\:text-gray-600 {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, 1);
  color: rgba(75, 85, 99, var(--tw-text-opacity));
}

.dark .dark\\:text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.dark .dark\\:placeholder-gray-400::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-placeholder-opacity));
}

.dark .dark\\:placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-placeholder-opacity));
}

.dark .dark\\:hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(26, 86, 219, 1);
  background-color: rgba(26, 86, 219, var(--tw-bg-opacity));
}

.dark .dark\\:hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, 1);
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));
}

.dark .dark\\:hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.dark .dark\\:focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(63, 131, 248, 1);
  border-color: rgba(63, 131, 248, var(--tw-border-opacity));
}

.dark .dark\\:focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.dark .dark\\:focus\\:ring-blue-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(30, 66, 159, var(--tw-ring-opacity));
}

.dark .dark\\:focus\\:ring-gray-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(55, 65, 81, var(--tw-ring-opacity));
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  -webkit-appearance: none;
          appearance: none;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  -webkit-appearance: none;
          appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,8BAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yCAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,mCAAc;UAAd;AAAc;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;KAAd,sBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,8BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iFAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,kBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,eAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,kBAAc;EAAd,kBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,gFAAc;EAAd,oGAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;EAAd;IAAA,2BAAc;IAAd,sBAAc;IAAd,0BAAc;IAAd,yBAAc;IAAd,wBAAc;IAAd,wBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,eAAc;IAAd,iBAAc;IAAd,eAAc;IAAd,yBAAc;IAAd,uBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,gDAAc;IAAd,uDAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,iBAAc;IAAd,iCAAc;EAAA;;EAAd;IAAA,2BAAc;IAAd,sBAAc;IAAd,0BAAc;IAAd,yBAAc;IAAd,wBAAc;IAAd,wBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,eAAc;IAAd,iBAAc;IAAd,eAAc;IAAd,yBAAc;IAAd,uBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,gDAAc;IAAd,uDAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,iBAAc;IAAd,iCAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,iMAAmB;EAAnB,qMAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,iLAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,kLAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,iEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,wHAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;KAAnB,0BAAmB;UAAnB;AAAmB;;AA6DnB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,+DAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,+DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gEAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gEAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gEAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gEAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gEAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gEAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gEAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gEAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gEAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gEAA4D;AAC9D;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,0BAA0B;AACtD;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;AACb;;;AAGA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,gEAAgE;EAChE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAhWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,wCAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,sCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,wCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,qCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA,2BAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,sBAiWA;EAjWA,mCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA,2BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,8BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2GAiWA;EAjWA,yGAiWA;EAjWA,gFAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2GAiWA;EAjWA,yGAiWA;EAjWA,gFAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2CAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,qCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2CAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2CAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA,aAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA,cAiWA;EAjWA;AAiWA;;AAjWA;EAAA;AAiWA;;AAjWA;EAAA,kFAiWA;EAjWA,yGAiWA;EAjWA,uHAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kFAiWA;EAjWA,yGAiWA;EAjWA,uHAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yDAiWA;EAjWA,iEAiWA;EAjWA,8FAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kFAiWA;EAjWA,yGAiWA;EAjWA,uHAiWA;EAjWA;AAiWA;;AAjWA;EAAA,+BAiWA;EAjWA,6KAiWA;EAjWA;AAiWA;;AAjWA;EAAA,+BAiWA;EAjWA,6KAiWA;EAjWA;AAiWA;;AAjWA;EAAA,sBAiWA;EAjWA,iCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,sBAiWA;EAjWA,iCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,uCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,qCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,qCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,yBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA,6BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA,0BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA,6BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2BAiWA;EAjWA,6BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2BAiWA;EAjWA,6BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,sCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,kBAiWA;EAjWA,qCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA,6BAiWA;EAjWA;AAiWA;;AAjWA;EAAA,sBAiWA;EAjWA,mCAiWA;EAjWA;AAiWA;;AAjWA;EAAA,2GAiWA;EAjWA,yGAiWA;EAjWA,gFAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,oBAiWA;EAjWA;AAiWA;;AAjWA;EAAA,wBAiWA;UAjWA;AAiWA;;AAjWA;EAAA,wBAiWA;UAjWA;AAiWA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n\n  :root {\n    --color-primary: 247 147 34;\n    --color-text: 33 33 33;\n    --color-light: 245 245 245;\n    --color-success: 0 200 81;\n    --color-info: 51 181 229;\n    --color-warn: 255 187 51;\n    --color-error: 254 78 78;\n    --color-surface: 23 23 23;\n    --color-accent: 235 255 66;\n    /* new colors */\n    --accent: #EBFF42;\n    --font: #FFFFFF;\n    --font-on-accent: #101010;\n    --font-variant: #A3A3A3;\n    --border: #101010;\n    --surface: #303030;\n    --font-disabled: #545454;\n    --surface-disabled: #222222;\n    --surface-active: #414141;\n    --surface-transparent: #FFFFFF0A;\n    --surface-transparent-active: #FFFFFF1F;\n    --success-new: #70FFBD;\n    --background: #1F1F1F;\n    --danger: #FA2565;\n    --overlay: #1515157A;\n  }\n\n  :root[class=\"dark\"] {\n    --color-primary: 247 147 34;\n    --color-text: 33 33 33;\n    --color-light: 245 245 245;\n    --color-success: 0 200 81;\n    --color-info: 51 181 229;\n    --color-warn: 255 187 51;\n    --color-error: 254 78 78;\n    --color-surface: 23 23 23;\n    --color-accent: 235 255 66;\n    /* new colors */\n    --accent: #EBFF42;\n    --font: #FFFFFF;\n    --font-on-accent: #101010;\n    --font-variant: #A3A3A3;\n    --border: #101010;\n    --surface: #303030;\n    --font-disabled: #545454;\n    --surface-disabled: #222222;\n    --surface-active: #414141;\n    --surface-transparent: #FFFFFF0A;\n    --surface-transparent-active: #FFFFFF1F;\n    --success-new: #70FFBD;\n    --background: #1F1F1F;\n    --danger: #FA2565;\n    --overlay: #1515157A;\n  }\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 900;\n  src: url('./fonts/Youth-Black.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 900;\n  font-style: italic;\n  src: url('./fonts/Youth-BlackItalic.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 700;\n  src: url('./fonts/Youth-Bold.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 700;\n  font-style: italic;\n  src: url('./fonts/Youth-BoldItalic.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 400;\n  font-style: italic;\n  src: url('./fonts/Youth-Italic.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 300;\n  src: url('./fonts/Youth-Light.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 300;\n  font-style: italic;\n  src: url('./fonts/Youth-LightItalic.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 500;\n  src: url('./fonts/Youth-Medium.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 500;\n  font-style: italic;\n  src: url('./fonts/Youth-MediumItalic.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 400;\n  src: url('./fonts/Youth-Regular.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 100;\n  src: url('./fonts/Youth-Thin.woff') format('opentype');\n}\n\n@font-face {\n  font-display: block;\n  font-family: 'Youth';\n  font-weight: 100;\n  font-style: italic;\n  src: url('./fonts/Youth-ThinItalic.woff') format('opentype');\n}\n\nbody {\n  margin: 0;\n  overflow: hidden;\n}\n\n.hide-scrollbars {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n}\n\n.hide-scrollbars::-webkit-scrollbar {\n  /* WebKit */\n  width: 0;\n  height: 0;\n  background: transparent;\n  display: none;\n}\n\n.icon {\n  position: relative;\n}\n\n.icon::before {\n  position: absolute;\n  left: 100%;\n  top: 0;\n  font-size: 0.9em;\n  display: block;\n}\n\n.icon.okay::before {\n  color: green;\n  content: \"✔\";\n}\n\n.icon.ignored::before {\n  /* content: '*️⃣'; */\n  color: darkgray;\n  opacity: 0.8;\n  content: \"✔\";\n}\n\n.icon.error::before {\n  content: \"⛔\";\n}\n\n.icon.warning::before {\n  content: \"⚠️\";\n}\n\n.globalError {\n  position: fixed;\n  background-color: #cf3939;\n  color: white;\n  bottom: 20px;\n  right: 20px;\n  opacity: 0.4;\n  padding: 20px;\n  z-index: 10000;\n  overflow: auto;\n  max-width: 30vw;\n  max-height: 30vh;\n}\n\n\n.popupContent {\n  text-align: center;\n}\n\n.popupContainer {\n  display: inline-block;\n}\n\npre {\n  text-align: left;\n}\n\n.buttons {\n  position: fixed;\n  right: 3vh;\n  bottom: 3vh;\n}\n\n\n.buttons>div {\n  size: 1vh;\n  color: white;\n  background: green;\n  text-align: center;\n  margin: 1vh;\n  padding: 1.1vh;\n  cursor: pointer;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  border-radius: 0.5vh;\n}\n\n.buttons.error>div {\n  background: grey;\n  cursor: not-allowed;\n}\n\n\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  background-color: black;\n  color: white;\n  font-family: monospace;\n  font-size: 12px;\n  padding: 10px;\n  height: 20vh;\n}\n\n.promptWrapper {\n  display: flex;\n}\n\n.line {\n  font-size: 12px;\n  line-height: 12px;\n  font-family: monospace;\n  background: transparent !important;\n  /* we want to make this transparent whatever happens in the app*/\n  padding: 0;\n  color: white;\n}\n\n.line.command {\n  font-weight: bold;\n}\n\n.line.error,\n.line.success {\n  padding-left: 20px;\n  position: relative;\n}\n\n.line.error {\n  color: #cf3939;\n  position: relative;\n}\n\n.line.error::before,\n.line.success::before {\n  display: block;\n  position: absolute;\n  top: 2px;\n  left: 0;\n}\n\n.line.error::before {\n  content: '❌ ';\n}\n\n.line.success::before {\n  content: '✅ ';\n}\n\n.prompt {\n  display: flex;\n  align-items: center;\n}\n\ninput:focus{\n  outline: none;\n  box-shadow: none;\n}\n\n.resultLabel {\n  color: dimgrey;\n}\n\n.warn {\n  color: darkorange;\n}\n\ntextarea {\n  resize: none;\n}\n\n.monaco-editor, .monaco-editor-background, .monaco-editor .margin {\n  background-color: transparent !important;\n}\n\n.monaco-editor {\n  --vscode-focusBorder: transparent !important;\n}\n\n.scroll-decoration {\n  visibility: hidden;\n}\n\n.margin-view-overlays .line-numbers::after {\n  content: '.';\n}\n\n.monaco-editor { \n  position: absolute !important; \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
